import { Layout, Result } from "antd";
// import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { GreenButton } from '../../components/button/GreenButton';
// import { Header } from "../components/Layout/header";

const NotFound = () => {
  const navigate = useNavigate();
//   const user = Cookies.get("jwt");

  return (
    <Layout style={{ minHeight: "90vh" }}>
      {/* <Header /> */}
      <Result
        style={{ margin: "auto" }}
        status="404"
        title="404"
        subTitle="ขออภัย ไม่พบหน้าที่คุณต้องการ"
        extra={
          <GreenButton
            type="primary"
            onClick={() => (navigate("/"))}
            width="fit-content"
          >
            กลับหน้าหลัก
          </GreenButton>
        }
      />
    </Layout>
  );
};

export default NotFound;
